import { backgroundLight, 
    ContentCardBackgroundLight, 
    textBackgroundLight,backgroundDark, 
    ContentCardBackgroundDark, 
    textBackgroundDark } from "./variaveis";

export const themeLight = {
    body: backgroundLight,
    inside: ContentCardBackgroundLight,
    text: textBackgroundLight,
    filter: '',
}

export const themeDark = {
    body: backgroundDark,
    inside: ContentCardBackgroundDark,
    text: textBackgroundDark,
    filter: 'invert(100%)',
}